import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import portalConfig from "../configurations/gil.config";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const token = useSelector((state: any) => state.auth.token);
  const authenticated = !!token; // Ensure boolean value

  const { unAuthenticateEntry} = portalConfig


  

  if (!authenticated) {
    //.log('User not authenticated, redirecting...');
    return <Navigate to={unAuthenticateEntry}  replace/>;
  }

  return <Outlet  />;
};

export default PrivateRoute;
